import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class DashboardService {

    constructor(private http: HttpClient) { }

    GetDashboard(): Observable<any> {
        return this.http.get("/dashboard").map((res: any) => res || {});
    };
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.service.ts